<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<div class="main-row" *ngIf="!isInstaMed()">
  <div class="col-md-12">
    <fieldset>
      <legend class="row" *ngIf="!collectingChargeBack">
        <div class="col-md-6 m-auto">Chargebacks</div>
        <div class="col-md-6">
          <button
            class="btn btn-primary float-right"
            *ngIf="hasFinanceRole()"
            (click)="collectingChargeBack = true"
          >
            <fa-icon [icon]="faUsd"></fa-icon>
            Collect Chargeback
          </button>
        </div>
      </legend>

      <div *ngIf="searchingForChargeBacks && !collectingChargeBack">
        <div>
          <app-load-spinner></app-load-spinner>
        </div>
      </div>

      <div *ngIf="!searchingForChargeBacks && !collectingChargeBack">
        <div *ngIf="chargebacks">
          <div
            class="btn btn-default"
            (click)="showChargebacks = !showChargebacks"
            *ngIf="chargebacks.length > 0"
          >
            <span class="fa fa-minus" *ngIf="showChargebacks"> </span>
            <span class="fa fa-plus" *ngIf="!showChargebacks"> </span>
          </div>

          <table
            class="table table-bordered table-condensed table-striped"
            *ngIf="showChargebacks && chargebacks.length > 0"
          >
            <thead>
              <tr>
                <th *ngFor="let header of chargebackProperties">
                  {{ header }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let chargeback of chargebacks">
                <td>{{ chargeback.chargebackDate | date: "MM-dd-YYYY" }}</td>
                <td>{{ chargeback.mfTransactionId }}</td>
                <td>{{ chargeback.parentExternalTransactionId }}</td>
                <td>{{ chargeback.chargebackAmount / 100 | currency }}</td>
                <td>
                  {{
                    !chargeback.chargebackFee || chargeback.status == "PENDING"
                      ? "PENDING"
                      : (chargeback.chargebackFee / 100 | currency)
                  }}
                </td>
                <td>
                  {{
                    !chargeback.chargebackFee || chargeback.status == "PENDING"
                      ? "PENDING"
                      : ((chargeback.chargebackAmount +
                          chargeback.chargebackFee) /
                          100 | currency)
                  }}
                </td>
                <td>{{ chargeback.status }}</td>
                <td>{{ chargeback.chargebackIssuer }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="!chargebacks || chargebacks.length == 0">
          <h4>There are no previous chargebacks.</h4>
        </div>
      </div>
      <div *ngIf="collectingChargeBack">
        <app-collect-chargebacks
          (cancelChargeBackEvent)="receiveCBEvent($event)"
          (collectChargeBackEvent)="receiveChargeBack($event)"
          [merchantId]="this.merchant.id"
          [merchant]="this.merchant"
        >
        </app-collect-chargebacks>
      </div>
    </fieldset>
  </div>
</div>
